import React, { useState } from 'react';
import { Select } from 'grommet';

type IProps = {
  options: string[];
  placeholder: string;
  onSort: Function;
};
const InputFilter = ({ options, placeholder, onSort }: IProps) => {
  const [value, setValue] = useState('');
  const onChange = ({ option }: { option: string }) => {
    onSort(option);
    setValue(option);
  };
  return (
    <Select
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export { InputFilter };
